import * as api from "services/api";

export const GET_INNS = "[INN] GET_INNS";
export const GET_INN_FAILED = "[INN] GET_INN_FAILED";
export const GET_INN_SUCCESS = "[INN] GET_INN_SUCCESS";

export const GET_ITEMS_PER_INN = "[INN] GET_ITEMS_PER_INN";
export const GET_ITEMS_PER_INN_FAILED = "[INN] GET_ITEMS_PER_INN_FAILED";
export const GET_ITEMS_PER_INN_SUCCESS =
	"[INN] GET_ITEMS_PER_INN_SUCCESS";

export const SET_VALUE = "[INN] SET_VALUE";
export const CLEAR_VALUE = "[INN] CLEAR_VALUE";

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function clearValue(payload) {
	return {
		type: CLEAR_VALUE,
		payload
	};
}

export function getInns(
	startDate,
	endDate,
	skip,
	take,
	filter,
	sort,
	desc,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_INNS
		});

		const { login } = getState();

		const { token } = login;

		let response = await api.sendGet(
			`/Inn?startDate=${startDate}&endDate=${endDate}&skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
				"&filters=null"}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_INN_SUCCESS,
					payload: result.model
				});

				if (result.params)
					dispatch(
						setValue({
							pages: Math.ceil(result.params.count / take),
							...result.params
						})
					);

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_INN_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_INN_FAILED });

			callback && callback("Ocorreu um erro ao tentar criar a venda");
		}
	};
}
